/**
 * blocks/index - side-effect module that registers every flagship print
 * block into blockRegistry. Import this module (for its side effect) before
 * resolving any block by type, e.g.:
 *
 *   import "./blocks/index.js";
 *   const Component = blockRegistry.get("status_badge");
 */
import blockRegistry from "./blockRegistry";

import StatusBadgeBlock from "./StatusBadgeBlock";
import ExecNarrativeBlock from "./ExecNarrativeBlock";
import SpendTableBlock from "./SpendTableBlock";
import CloudAiSplitBlock from "./CloudAiSplitBlock";
import MoMChangeBlock from "./MoMChangeBlock";
import DriverTableBlock from "./DriverTableBlock";
import ForecastTableBlock from "./ForecastTableBlock";
import BudgetComparisonBlock from "./BudgetComparisonBlock";
import NotesConfidenceBlock from "./NotesConfidenceBlock";
import NotesBlock from "./NotesBlock";
import PageSummaryBlock from "./PageSummaryBlock";
import KPIStripBlock from "./KPIStripBlock";
import DecisionBlock from "./DecisionBlock";
import StackedTrendBlock from "./StackedTrendBlock";
import PerformanceTableBlock from "./PerformanceTableBlock";
import VarianceWaterfallBlock from "./VarianceWaterfallBlock";
import ForecastBandBlock from "./ForecastBandBlock";
import HorizonTableBlock from "./HorizonTableBlock";
import ForecastMonthlyTableBlock from "./ForecastMonthlyTableBlock";
import DataQualityBlock from "./DataQualityBlock";
import DetailedCostBlock from "./DetailedCostBlock";
import AppendixNotesBlock from "./AppendixNotesBlock";
import RiskBridgeBlock from "./RiskBridgeBlock";
import BudgetRiskOverviewBlock from "./BudgetRiskOverviewBlock";
import BudgetVarianceTableBlock from "./BudgetVarianceTableBlock";
import BudgetOwnershipTableBlock from "./BudgetOwnershipTableBlock";
import PreventiveActionsBlock from "./PreventiveActionsBlock";
import SavingsSummaryKpisBlock from "./SavingsSummaryKpisBlock";
import ImplementedActionsTableBlock from "./ImplementedActionsTableBlock";
import OpenOpportunitiesTableBlock from "./OpenOpportunitiesTableBlock";
import SavingsVerificationTableBlock from "./SavingsVerificationTableBlock";

blockRegistry.register("status_badge", StatusBadgeBlock);
blockRegistry.register("exec_narrative", ExecNarrativeBlock);
blockRegistry.register("spend_table", SpendTableBlock);
blockRegistry.register("cloud_ai_split", CloudAiSplitBlock);
blockRegistry.register("mom_change", MoMChangeBlock);
blockRegistry.register("driver_table", DriverTableBlock);
blockRegistry.register("forecast_table", ForecastTableBlock);
blockRegistry.register("budget_comparison", BudgetComparisonBlock);
blockRegistry.register("notes_confidence", NotesConfidenceBlock);
blockRegistry.register("notes", NotesBlock);
blockRegistry.register("page_summary", PageSummaryBlock);
blockRegistry.register("kpi_strip", KPIStripBlock);
blockRegistry.register("decision", DecisionBlock);
blockRegistry.register("stacked_trend", StackedTrendBlock);
blockRegistry.register("performance_table", PerformanceTableBlock);
blockRegistry.register("variance_waterfall", VarianceWaterfallBlock);
blockRegistry.register("forecast_band", ForecastBandBlock);
blockRegistry.register("horizon_table", HorizonTableBlock);
blockRegistry.register("forecast_monthly_table", ForecastMonthlyTableBlock);
blockRegistry.register("data_quality", DataQualityBlock);
blockRegistry.register("detailed_cost", DetailedCostBlock);
blockRegistry.register("appendix_notes", AppendixNotesBlock);
blockRegistry.register("risk_bridge", RiskBridgeBlock);
blockRegistry.register("budget_risk_overview", BudgetRiskOverviewBlock);
blockRegistry.register("budget_variance_table", BudgetVarianceTableBlock);
blockRegistry.register("budget_ownership_table", BudgetOwnershipTableBlock);
blockRegistry.register("preventive_actions", PreventiveActionsBlock);
blockRegistry.register("savings_summary_kpis", SavingsSummaryKpisBlock);
blockRegistry.register("implemented_actions_table", ImplementedActionsTableBlock);
blockRegistry.register("open_opportunities_table", OpenOpportunitiesTableBlock);
blockRegistry.register("savings_verification_table", SavingsVerificationTableBlock);

export default blockRegistry;
